import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { ControlSlider } from '../../clases/ControlSlider';
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'control-slider',
  standalone: true,
  imports: [
    CommonModule,
    MatSliderModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule
],
  templateUrl: './control-slider.component.html',
  styleUrl: './control-slider.component.scss'
})
export class ControlSliderComponent {
  showSettings: boolean = false;
  @Input() control!: ControlSlider;

  toggleSettings(){
    this.showSettings = !this.showSettings;
  }
}
